module.exports = __webpack_public_path__ + "img/fish6.ccb3fd4a.png";